module.exports = __webpack_public_path__ + "static/media/wellness-monster.136eb9ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/wellness-monster.png
// module id = 1227
// module chunks = 0